import { useEffect, useRef } from "react"

import { Flex } from "antd"
import { useSelector } from "react-redux"
import { useNavigate, useSearchParams } from "react-router-dom"

import ButtonComponent from "../../../../Components/Button"
import useDemoBannerVisible from "../../../../hooks/useDemoBannerVisible"
import Icon from "../../../../Icon"

import "./index.less"

/**
 * Common layout wrapper for Health subpages
 * Provides back button, scroll behavior, and consistent padding
 */
const HealthSubpageLayout = ({
  children,
  backText = "Back to Health",
  backPath,
  pageTitle = "Health - Chargeback",
  minHeight = "100vh",
  gap = 24,
  isMobile
}) => {
  const navIsMobile = useSelector((state) => state.nav.isMobile)
  const resolvedIsMobile = isMobile ?? navIsMobile
  const pageRef = useRef()
  const navigate = useNavigate()
  const [, setSearchParams] = useSearchParams()
  const isDemoBannerVisible = useDemoBannerVisible()

  useEffect(() => {
    document.title = pageTitle
    if (pageRef.current) {
      pageRef.current?.scrollIntoView({ behavior: "smooth" })
    }
  }, [pageTitle])

  const goBack = () => {
    if (!backPath) {
      navigate(-1)
      return
    }
    navigate(backPath)
  }
  return (
    <Flex
      ref={pageRef}
      gap={gap}
      vertical={true}
      className={isDemoBannerVisible ? "health-subpage-demo-offset" : undefined}
      style={{ padding: resolvedIsMobile ? "16px" : "32px 32px 0", minHeight }}
    >
      <div>
        <ButtonComponent
          type={"text"}
          onClick={goBack}
          icon={<Icon type={"chevron_left_small"} />}
          style={{ marginLeft: "-12px" }}
        >
          {backText}
        </ButtonComponent>
      </div>
      {children}
    </Flex>
  )
}

export default HealthSubpageLayout
